<tt-page>
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <tt-card *ngIf="itemState === 'p2webpageedit'" class="col-xs-12 col-md-6 p-5">
            <tt-page-heading ttModel="h_p2webpage" ttTranslate></tt-page-heading>
        </tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-input
                    *ngIf="!!setting"
                    ttLabel="searchtext"
                    [(ttModel)]="setting.searchtext"
                    (ttOnBlur)="onSearchTextBlur()"
                    [ttButtons]="searchTextButtons">
                </tt-input>
            </tt-card>
            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="new_p2_webpage" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createPage($event)"></tt-button>
            </tt-card>
        </div>

        <ng-container *ngIf="itemState !== 'p2webpageedit'; else inlineEditor">
            <tt-list [ttData]="pages" [ttFilter]="setting?.searchtext" (ttClick)="openPage($event.item, $event.event)"></tt-list>
        </ng-container>
        <ng-template #inlineEditor>
            <div class="col-xs-12 col-md-6 p-5">
                <tt-list [ttData]="pages" [ttFilter]="setting?.searchtext" (ttClick)="openPage($event.item, $event.event)"></tt-list>
            </div>
            <div *ngIf="selectedPageKeyno !== ''" class="col-xs-12 col-md-6 p-5">
                <tt-p2-webpage-edit
                    [p2WebpageKeyno]="selectedPageKeyno"
                    [inline]="true"
                    (onSave)="updateList()">
                </tt-p2-webpage-edit>
            </div>
        </ng-template>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <tt-input
                *ngIf="!!setting"
                ttLabel="searchtext"
                [(ttModel)]="setting.searchtext"
                (ttOnBlur)="onSearchTextBlur()"
                [ttButtons]="searchTextButtons">
            </tt-input>
            <tt-button-goto
                ttText="new_p2_webpage"
                ttGoto="p2webpageedit-test"
                [ttGotoParms]="{ p2_webpage_keyno: '0' }"
                ttTextAlign="left"
                ttIcon="fas fa-plus">
            </tt-button-goto>
        </tt-card>
        <tt-list [ttData]="pages" [ttFilter]="setting?.searchtext" (ttClick)="openPage($event.item, $event.event)"></tt-list>
    </ng-template>
</tt-page>
